<template>
  <div class="outer-online-wrapper">
    <vheader v-if="type_stup" :is_reg="false" />
    <stup v-if="type_stup" :type="type_stup" />

    <div class="start" v-else>
      <agree
        v-if="!start"
        :agree="agree"
        :loading="loading"
        @next_step="start_room"
        @set_value="set_value"
      />

      <div class="room-wrapper" v-else>
        <room
          :is_record="false"
          :data="room"
          :recruiter="false"
          :participants_data="participants"
          @end_room="end_room"
          @end_room_too_many="end_room_too_many"
        />
      </div>
    </div>
    <vfooter background="#fff" />
  </div>
</template>

<script>
  import BrowserStore from 'store';
  import IEBrowserDetector from '@/components/mixin/IEBrowserDetector.js';
  import SafariBrowserDetector from '@/components/mixin/SafariBrowserDetector.js';
  import isMobile from 'ismobilejs';
  import vfooter from '@/routes_new/outer/components/vfooter.vue';
  import agree from './components/agree.vue';
  import room from '@/components/online_interview/index.vue';
  import stup from '@/components/online_interview/stup/index.vue';
  import vheader from '@/routes_new/outer/components/vheader.vue';

  export default {
    name: 'online_interview',

    components: {
      vfooter,
      agree,
      room,
      vheader,
      stup
    },

    mixins: [IEBrowserDetector, SafariBrowserDetector],

    props: {
      token: {
        type: String,
        required: true
      }
    },

    data() {
      return {
        agree: false,
        start: false,
        isMobile: isMobile.any,
        finish_room: false,
        stop_link: false,
        active_link: true,
        too_many: false,
        participants: []
      };
    },

    created() {
      this.load();
    },

    computed: {
      loading() {
        return this.$store.getters['online_interview/loading'];
      },

      room() {
        return this.$store.getters['online_interview/room_online'];
      },

      is_active() {
        return this.room ? this.room.is_active : true;
      },

      type_stup() {
        if (this.isMobile) {
          return 'mobile';
        } else if (this.isIE11OrOlder || this.isEdge || this.isSafari) {
          return 'bad_browser';
        } else if (this.finish_room) {
          return 'finish';
        } else if (!this.is_active || !this.active_link) {
          return 'no_active';
        } else if (this.stop_link) {
          return 'stop_link';
        } else if (this.too_many) {
          return 'too_many';
        } else {
          return '';
        }
      }
    },

    methods: {
      load() {
        this.$store.dispatch('online_interview/room', this.token);
      },

      start_room(v) {
        if (this.agree) {
          this.$store
            .dispatch('online_interview/join', {
              value: v,
              token: this.token
            })
            .then(data => {
              this.participants = data.participants;
              this.start = this.agree;
            })
            .catch(err => {
              const error = err.response.data.meta.error;
              if (error.message === 'User already connected') {
                this.stop_link = true;
              } else {
                this.active_link = false;
              }
            });
        }
      },

      set_value(v) {
        this.agree = v;
      },

      end_room() {
        this.finish_room = true;
      },

      end_room_too_many() {
        this.too_many = true;
      }
    },

    beforeMount() {
      if (
        BrowserStore.get(`room_join_${this.token}`) &&
        !BrowserStore.get('access_token')
      ) {
        this.stop_link = true;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .start {
    position: relative;
    width: 100%;
    min-height: calc(100vh - 40px);

    .logo {
      width: 100%;
      height: 250px;
      background: #d9d9da;
    }
  }

  .outer-online-wrapper ::v-deep .stup {
    height: calc(100vh - 98px);
  }
</style>
